import axios from 'axios';
import { Axios } from './Axios';
import { getCke } from '../helper/cookieHelper';

export async function sendOtp(mobileNumber) {
  const url = `/auth/send-otp?mobileNumber=${mobileNumber}`;
  return Axios({
    url,
    method: 'get'
  });
}

export async function verifyOtp(data) {
  const url = `/auth/verify-otp`;
  return Axios({
    url,
    method: 'post',
    data
  });
}

export async function verifyMobileOtp(data) {
  const url = `/auth/verify-mobile-otp`;
  return Axios({
    url,
    method: 'post',
    data
  });
}

export async function generateNewAccessToken() {
  return axios({
    url: `${process.env.REACT_APP_REST_API_URL}/auth/refresh-tokens`,
    method: 'POST',
    data: {
      refreshToken: getCke('refreshToken')
    }
  });
}

export async function getUserFromEmail(email) {
  const url = `/pub/users?email=${email}`;
  return Axios({
    url,
    method: 'get'
  });
}

export async function getUserFromMobile(mobileNumber) {
  const url = `/pub/users?mobileNumber=${mobileNumber}`;
  return Axios({
    url,
    method: 'get'
  });
}
